module.exports = __webpack_public_path__ + "static/img/case_detail_04_1.36b45b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_04_1.png
// module id = LD4W
// module chunks = 34